import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import { clearReadOnly } from '../lib/readOnly';
import { toast } from '../components/ui/toastStore';
import { clearOfflineData } from '../features/platform/offline/clearOfflineData';

/** POST /api/auth/logout, clear cached data and go to the sign-in page. */
export function useSignOut() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [pending, setPending] = useState(false);
  const signOut = useCallback(async () => {
    setPending(true);
    try {
      await api.post('/api/auth/logout', undefined, { redirectOn401: false });
    } catch {
      // Even if the request fails, clear local state: the session cookie may already be gone.
    } finally {
      queryClient.clear();
      clearReadOnly();
      void clearOfflineData(); // ADR 0004: the offline outbox is cleared on sign-out (platform/offline)
      setPending(false);
      navigate('/sign-in', { replace: true });
      toast({ title: 'You have signed out', tone: 'success' });
    }
  }, [navigate, queryClient]);
  return { signOut, pending };
}
